import { IFilter } from '@epicuro-next/ataraxia/models';
import { FiltersFieldIds } from '@epicuro-next/models/order-book';

import { isIncomingFilter } from '../../shared/is-incoming-filter/is-incoming-filter';

export const getActiveFiltersAfterFilterToggle = (
  activeFilters: IFilter[],
  toggledFilter: IFilter,
  isMultiple: boolean,
): IFilter[] => {
  if (toggledFilter.fieldId === FiltersFieldIds.DeliveryYear) {
    return [
      // Do not clean order status when year changed
      ...activeFilters.filter(isIncomingFilter),
      toggledFilter,
    ];
  }

  const newActiveFilter = activeFilters.filter((active) => {
    if (isMultiple) {
      return (
        active.fieldId !== toggledFilter.fieldId ||
        active.value !== toggledFilter.value
      );
    }
    return active.fieldId !== toggledFilter.fieldId;
  });

  if (newActiveFilter.length === activeFilters.length || !isMultiple) {
    newActiveFilter.push(toggledFilter);
  }

  return newActiveFilter;
};
